import { getChartTheme } from "../../utils/chartTheme";

export function buildPortfolioIntroChartOptions(
  isDarkMode,
  unitPrefix = "",
  unitSuffix = "",
  compact = false
) {
  const theme = getChartTheme(isDarkMode);
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: theme.tooltipBg,
        titleColor: theme.tooltipTitle,
        bodyColor: theme.tooltipBody,
        borderColor: theme.tooltipBorder,
        borderWidth: 1,
        callbacks: {
          label: (context) => {
            const rawValue = context.parsed?.y;
            if (!Number.isFinite(rawValue)) return "-";
            return `${unitPrefix}${rawValue}${unitSuffix}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: theme.tickColor,
          font: { size: 10 },
          maxRotation: 0,
          minRotation: 0,
          autoSkip: true,
          maxTicksLimit: 6,
          display: !compact,
        },
        grid: { display: false },
        border: compact ? { display: false } : { color: theme.borderColor },
      },
      y: {
        ticks: {
          color: theme.tickColor,
          callback: (value) => `${unitPrefix}${value}${unitSuffix}`,
          display: !compact,
        },
        grid: compact ? { display: false } : { color: theme.gridColor },
        border: compact ? { display: false } : { color: theme.borderColor },
      },
    },
  };
}
